import { useCompassCard } from '@scale/compass-ui/store';
import { EvalConfig, ModelEvalContext } from '@scale/genai-compass-shared/cards/model_eval/card';
import { useEffect } from 'react';
import { columnsFromRecord } from '@scale/compass-shared/utils';

function useModelEvalCard(index: number) {
  const { card, updateCardContext, error } = useCompassCard<ModelEvalContext>(index);
  const { retrievedOutput } = useCompassCard(index - 1);
  const context = card.defaultContext;

  const data = retrievedOutput?.response?.data ?? [];
  const firstDataRow = data.length ? data[0] : undefined;
  const availableVariables = columnsFromRecord(data).map(col => col.header);
  const useCache = context.useCache;

  const setUseCache = (useCache: boolean) => {
    updateCardContext({ ...context, useCache });
  };

  const setEvalConfigs = (evalConfigs: EvalConfig[]) => {
    updateCardContext({ ...context, evalConfigs } as ModelEvalContext);
  };

  const setProjectId = (projectId: string) => {
    updateCardContext({ ...context, projectId } as ModelEvalContext);
  };

  useEffect(() => {
    if (
      context.evalConfigs.every(
        config =>
          config.modelConfigs &&
          config.modelConfigs.length &&
          config.outputColumn &&
          config.promptTemplate,
      ) &&
      context.projectId
    ) {
      // updateCardCanSubmit(true);
    } else {
      // updateCardCanSubmit(false);
    }
  }, [context]);

  return {
    evalConfigs: context.evalConfigs,
    setEvalConfigs,
    useCache,
    setUseCache,
    projectId: context.projectId,
    setProjectId,
    firstDataRow,
    availableVariables,
    hasError: !!error,
  };
}

export default useModelEvalCard;
